<template>
  <div class="content-wrapper">
    <div class="thank-you">
      <h1 class="align-center">Thank You!</h1>
      <p>
        An advisor from Believe Loans will be in contact shortly.
      </p>
      <p>
        They will be calling from number <strong>01302 591 315</strong> to run
        through your application.
      </p>
      <router-link to="/">
        Take me Home
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "ThankYouBelieveLoans",
  mounted() {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-437552222/NN1aCJqEsvoCEN6I0tAB"
      });
    }
  }
};
</script>
<style lang="scss">
.thank-you {
  padding: 70px 0;

  h1 {
    margin-bottom: 40px;
  }

  a {
    @include button-yellow;
    margin-top: 20px;
    @include breakpoint-max-($smallScreen) {
      margin-top: 40px;
    }
  }
}
</style>
